import store from '@/store/store';

export default {
  path: 'members',
  name: 'app-view-members',
  component: () => import('@/views/app/view_members/ViewMembers.vue'),
  meta: {
    pageTitle: 'View Members'
  },
  beforeEnter: async (to, from, next) => {
    to.meta.pageTitle = 'view_members.header_title';
    const membersResource = await store.state.router.privateRoot.$request().$get('members');
    store.commit('router/updateRouteProp', {
      property: 'membersResource',
      value: membersResource
    });
    next();
  },
  props: () => ({
    membersResource: store.state.router.membersResource
  })
};
